document.addEventListener('DOMContentLoaded', function(){

    const initializeSlider = (sliderElement) => {
        const sliderAutoplay = +sliderElement.dataset.autoplay;
        const sliderArrows = sliderElement.dataset.arrows;
        const sliderButtonPrev = sliderElement.querySelector('.collections-sliders__prev');
        const sliderButtonNext = sliderElement.querySelector('.collections-sliders__next');
        const sliderPagination = sliderElement.querySelector('.collections-sliders__pagination');

        const sliderSettings = {
            breakpoints: {
                0: {
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                    spaceBetween: 4.18,
                    grid: {
                        rows: 2,
                        fill: "row",
                    }
                },
                576: {
                    slidesPerGroup: 1,
                    slidesPerView: 2,
                    spaceBetween: 10,
                    grid: {
                        rows: 1,
                    }
                },
                991: {
                    slidesPerGroup: 1,
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                1199: {
                    slidesPerGroup: 1,
                    slidesPerView: 4,
                    spaceBetween: 10
                },
                1400: {
                    slidesPerGroup: 1,
                    slidesPerView: 5,
                    spaceBetween: 10
                },
            }
        };

        if (sliderAutoplay !== 0) {
            sliderSettings.autoplay = {delay: sliderAutoplay * 1000};
        }

        if (sliderArrows) {
            sliderSettings.navigation = {nextEl:sliderButtonNext, prevEl: sliderButtonPrev};
        }
        if (sliderPagination) {
            sliderSettings.pagination = {
                el: sliderPagination,
                type: "fraction"
            }
        }

        return new Swiper(sliderElement, sliderSettings);
    };

    const initializeAllSliders = () => {
        const sliders = document.querySelectorAll('.collections-sliders__slider');
        sliders.forEach(initializeSlider);
    };

    initializeAllSliders();

    const scrollTopButtons = document.querySelectorAll(".collections-sliders__button button");

    scrollTopButtons.forEach( (button) => {
        button.addEventListener("click", function() {
            const { firstElementChild } = document.querySelector("main");
            scrollToElement(firstElementChild)
            
        })
    }) 

    function scrollToElement(element) {
        if (!element) return;
        const yOffset = -document.querySelector("header").getBoundingClientRect().height
        const yCoord = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: yCoord, behavior: 'smooth'});
    
      }

});
